import axios from 'axios';
// Determine API URL based on environment - must be called in browser context
function getAPIBaseURL() {
    const envURL = import.meta.env.VITE_API_URL;
    if (envURL) {
        return `${envURL.replace(/\/$/, '')}/api/v1`;
    }
    if (typeof window !== 'undefined') {
        const hostname = window.location.hostname;
        if (hostname === 'localhost' || hostname === '127.0.0.1') {
            return 'http://localhost:6162/api/v1';
        }
        // Production and test domains: use relative path — routed through load balancer
        if (hostname === 'test.snapv.ai' || hostname === 'www.test.snapv.ai' ||
            hostname === 'snapv.ai' || hostname === 'www.snapv.ai') {
            return '/api/v1';
        }
    }
    return '/api/v1';
}
// Create client with dynamic base URL
const client = axios.create({
    baseURL: getAPIBaseURL(),
    headers: {
        'Content-Type': 'application/json',
    },
});
// Add JWT token to requests
client.interceptors.request.use(config => {
    const token = localStorage.getItem('auth_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});
// Handle errors
client.interceptors.response.use(response => response, (error) => {
    if (error.response?.status === 401) {
        // Don't redirect on auth endpoints — let the form handle the error
        const url = error.config?.url || '';
        const isAuthEndpoint = url.includes('/auth/');
        if (!isAuthEndpoint) {
            localStorage.removeItem('auth_token');
            window.location.href = '/login';
        }
    }
    return Promise.reject(error);
});
export default client;
